var appName = 'Chybi nazev aplikace';


appName = 'Freeware Autovraky 2.1.4';

export default appName;



// WEBPACK FOOTER //
// build/appName.js